export default {
	site_name: 'fritz',
};
